import { Component, OnDestroy, OnInit, ViewEncapsulation, ChangeDetectorRef, AfterViewInit } from '@angular/core';
import { AddDialogComponent } from 'app/modules/app-components/add-dialog/add-dialog.component';
import { DialogService, DynamicDialogRef, DynamicDialogConfig } from 'primeng/dynamicdialog';

import { DataService, HelperService, HTTPService, CalculationService, FormatService } from 'app/services';

import { findIndex, find, debounce } from 'lodash';
import { ConfirmDismissDialogComponent, ProcessingDismissDialogComponent, PaymentOptionDialogComponent } from 'app/modules/shared/components';
import { config } from 'app/constants';

@Component({
  selector: 'app-vehicle-specific-lookup-dialog',
  templateUrl: './vehicle-specific-lookup-dialog.component.html',
  styleUrls: ['./vehicle-specific-lookup-dialog.component.scss'],
  providers: [DialogService],
  encapsulation: ViewEncapsulation.None,
})
export class VehicleSpecificLookupDialogComponent implements OnInit, AfterViewInit {
  showLoaderOnDD: boolean = false;
  isLoading: boolean = true;
  isTireSizesLoading: boolean = true;
  isEmptySizes: boolean = false;
  isCartVisible: boolean = false;
  isTireSelected: boolean = false;

  sessionId: string = '';
  orderId: string = '';
  cartId: string = '';
  dialogTitle: string = '';
  vehicle: any = {};
  services: any[] = [];
  inventoryTires: any[] = [];
  recommendedSizes: any[] = [];

  tireWidths: any[] = [];
  tireSizes: any[] = [];
  tireProfiles: any[] = [];

  brands: any[] = [];
  seasons: any[] = [];
  loadIndexes: any[] = [];
  speedRatings: any[] = [];
  warehouses: any[] = [];

  selectedAttr = {
    tireWidth: { _id: null },
    tireProfile: { _id: null },
    tireSize: { _id: null },
  };
  selectedTire: any = {};
  searchQuery: string = '';
  selectedTab: number = 0;
  selectedTireSize: string = '';
  selectedItemCount = {
    autoleap: 0,
    tirehub: 0,
    tireConnect: 0,
  };
  //isTireHubConnected: boolean = false;
  pageSize: number = 12;
  pageNumber: number = 1;
  isTireConnectEnabled: boolean = false;
  selectedRecommended: any = {};
  tireConnectSettings: any = {};
  tireHubSettings: any = {};
  attrType: string = '';
  isOpenFromQuickTireLookup: boolean = false;
  vehicleQuery: string = '';
  isVehicleSearching: boolean = false;
  searchVehicleBy: string = '';
  vehicleSuggestions: any[] = [];
  isQuickTireLookupEnabled: boolean = false;
  isTireHubEnabled: boolean = false;
  isOpenFromRO: boolean = false;
  filterOptions = {
    multipleGenericFilters: true,
  };
  multipleGenericFiltersKeys: any = ['pricingMatrix', 'companyTaxes', 'adonServices', 'tireQuantity'];
  filterOptionStylecss: any = {
    width: '120px',
    'font-weight': '600',
    padding: '0 3px',
  };

  pricingMatrixOptions = [
    { name: 'Regular Customers Pricing', value: 'regular', showSelected: 'Regular Customers Pricing' },
    { name: 'Fleet Customers Pricing', value: 'fleet', showSelected: 'Fleet Customers Pricing' },
    { name: 'TireHub Pricing', value: 'tireHub', showSelected: 'TireHub Pricing' },
  ];
  multipleGenericFiltersObject: any = {
    tireQuantity: {
      data: [],
      filterOptions: {
        iconClass: 'fa-list-ul',
        nameField: 'name',
        valueField: 'value',
        labelFieldToShowAsSelected: 'showSelected',
        selectAllText: 'Qty',
        multipleSelectText: '',
        styleCss: this.filterOptionStylecss,
        filterOverlayStyle: {
          width: '130px',
        },
        isSingleSelect: true,
        width: '105px',
      },
      filterApplied: true,
      selected: [{ name: '4', value: 4, showSelected: 'Qty: 4' }],
      hideCross: true,
      searchFilterObj: {
        isSearchEnable: true,
        searchPlaceholder: 'Search',
        serachField: 'value',
        maxLength: 2,
      },
    },
    adonServices: {
      data: [],
      filterOptions: {
        iconClass: 'fa-plus-circle',
        nameField: 'title',
        valueField: '_id',
        selectAllText: 'Add-on',
        multipleSelectText: '',
        styleCss: {
          width: '230px',
          'font-weight': '600',
          padding: '0 3px',
        },
        filterOverlayStyle: {
          width: '200px',
        },
        isSingleSelect: true,
        width: '200px',
      },
      filterApplied: true,
      selected: [],
      hideCross: true,
      searchFilterObj: {
        isSearchEnable: false,
        searchPlaceholder: 'Search',
        serachField: 'value',
        maxLength: 2,
      },
    },
    companyTaxes: {
      data: [],
      filterOptions: {
        iconClass: 'fa-list-ul',
        nameField: 'name',
        valueField: 'id',
        selectAllText: 'Taxes',
        multipleSelectText: '',
        styleCss: this.filterOptionStylecss,
        filterOverlayStyle: {
          width: '175px',
        },
        isSingleSelect: true,
        width: '145px',
      },
      filterApplied: true,
      selected: [{ name: 'Sales tax(GST-6%)', value: 4 }],
      hideCross: true,
      searchFilterObj: {
        isSearchEnable: false,
        searchPlaceholder: 'Search',
        serachField: 'value',
        maxLength: 2,
      },
    },
    pricingMatrix: {
      data: this.pricingMatrixOptions,
      filterOptions: {
        iconClass: '../../../../../assets/img/dollar-sign.png',
        isIconImage: true,
        nameField: 'name',
        valueField: 'value',
        labelFieldToShowAsSelected: 'showSelected',
        selectAllText: 'Regular Customers Pricing',
        multipleSelectText: '',
        // styleCss: this.filterOptionStylecss,
        styleCss: {
          width: '200px',
          'font-weight': '600',
          padding: '0 3px',
        },
        filterOverlayStyle: {
          width: '190px',
        },

        isSingleSelect: true,
        width: '190px',
      },
      filterApplied: true,
      selected: [{ name: 'Regular Customers Pricing', value: 'regular', showSelected: 'Regular Customers Pricing' }],
      hideCross: true,
    },
  };

  selectedQty: number = 4;
  isQTQAddOnEnable: boolean = this.dataService.isQTQAddOnEnable;
  globalCartItemList: any[] = [];
  globalCartItemMap: any = {};
  globalCartCount: number = 0;
  hideCost: boolean = false;
  isSubmitting: boolean = false;
  shippingLoader: boolean = false;
  isShippingCalculating: boolean = false;

  adOnServicesObj: any = {};

  defaultAdonService: any = {};
  isAdOnServicesLoads: boolean = false;
  defaultServiceTotal: number = 0;
  globalCartOrderTotal: number = 0;
  isAllCountAvailable: boolean = false;
  isEditMode: boolean = false;
  roCode: string = '';

  tireSearchSizeFocus: any = {
    tireWidth: false,
    tireProfile: false,
    tireSize: false,
  };
  isTaxesLoaded: boolean = false;
  isPassThroughTaxEnable: boolean = this.dataService.isPassThroughTaxEnable;
  selectedTax: any = {};
  roSelectedTax: any = {};
  selectedPricingMatrix = { name: 'Regular Customers Pricing', value: 'regular', showSelected: 'Regular Customers Pricing' };
  isOpenFromReplenishment: boolean = false;
  taxAmtOnAdonService: number = 0;
  stockReplenishmentTireList: any[] = [];
  partNumberInput: string = '';
  orderFrom: string = '';
  customFleetSettings: any = {};
  tireConnectList: any[] = [];
  tireHubList: any[] = [];
  alPricingList: any[] = [];
  isRunTireStorageFlow: boolean = false;
  isTireStorage2Enabled: boolean = false;
  tireStorageId: string = '';

  constructor(
    private httpService: HTTPService,
    private helperService: HelperService,
    private dynamicDialogRef: DynamicDialogRef,
    private dynamicDialogConfig: DynamicDialogConfig,
    private dataService: DataService,
    private cdr: ChangeDetectorRef,
    private dialogService: DialogService,
    private calculationService: CalculationService,
    private formatService: FormatService,
  ) { }

  ngAfterViewInit(): void {
    if (!this.isOpenFromReplenishment) {
      this.isLoading = false;
      this.isTireSizesLoading = false;
      if (this.isTireHubEnabled && this.orderFrom === 'tireHub') {
        this.pricingMatrixOptions = this.tireHubList;
        this.multipleGenericFiltersObject.pricingMatrix.data = this.pricingMatrixOptions;
        this.selectedTab = 1;
      } else if (this.isTireConnectEnabled && this.orderFrom === 'tireConnect') {
        this.pricingMatrixOptions = this.tireConnectList;
        this.multipleGenericFiltersObject.pricingMatrix.data = this.pricingMatrixOptions;

        this.selectedTab = 2;
      } else {
        this.selectedTab = 0;
      }
    }
  }

  ngOnInit() {
    const {
      vehicle,
      services,
      selectedTab,
      orderId,
      sessionId,
      isCartVisible,
      isTireConnectConnected,
      isTireHubConnected,
      tireConnectSettings,
      isOpenFromQuickTireLookup,
      isQuickTireLookupEnabled,
      headingTitle,
      tireHubSettings,
      isOpenFromRO,
      isEditMode,
      roCode,
      roSelectedTax,
      isOpenFromReplenishment,
      stockReplenishmentTireList,
      orderFrom,
      customFleetSettings,
      customer,
      isRunTireStorageFlow,
      tireStorageId,
    } = this.dynamicDialogConfig.data;

    this.sessionId = sessionId;
    this.orderId = orderId;
    this.services = services;
    this.vehicle = vehicle;
    this.isCartVisible = isCartVisible;
    this.selectedTab = selectedTab ?? 0;
    this.isOpenFromReplenishment = isOpenFromReplenishment;
    //this.isTireHubConnected = this.dataService.isTireHubEnabled;
    this.isTireHubEnabled = this.dataService.isTireHubEnabled && isTireHubConnected;
    this.isTireConnectEnabled = this.dataService.isTireConnectEnabled && isTireConnectConnected;
    this.isTireStorage2Enabled = this.dataService.isTireStorage2Enabled;
    this.tireConnectSettings = tireConnectSettings;
    this.isOpenFromQuickTireLookup = isOpenFromQuickTireLookup;
    this.isQuickTireLookupEnabled = isQuickTireLookupEnabled;
    this.tireHubSettings = tireHubSettings;
    this.isOpenFromRO = isOpenFromRO;
    this.isEditMode = isEditMode;
    this.roCode = roCode;
    this.roSelectedTax = roSelectedTax;
    this.stockReplenishmentTireList = stockReplenishmentTireList || [];
    this.orderFrom = orderFrom;
    this.customFleetSettings = this.helperService.deepCopy(customFleetSettings);
    this.isRunTireStorageFlow = isRunTireStorageFlow;
    this.tireStorageId = tireStorageId || '';
    if (this.tireConnectSettings?.tire?.pricingRule?.length) {
      this.tireConnectList = this.formatService.formatPricingMatrixList(this.tireConnectSettings?.tire?.pricingRule);
      this.tireConnectList.push({ name: 'TireConnect Pricing', value: 'tireConnect', showSelected: 'TireConnect Pricing' });
    }

    if (tireHubSettings?.tire?.pricingRule?.length) {
      this.tireHubList = this.formatService.formatPricingMatrixList(this.tireHubSettings?.tire?.pricingRule);
      this.tireHubList.push({ name: 'TireHub Pricing', value: 'tireHub', showSelected: 'TireHub Pricing' });
    }

    if (this.isTireConnectEnabled && this.orderFrom === 'tireConnect') {
      // this.pricingMatrixOptions.pop();
      // this.pricingMatrixOptions.push({name: 'TireConnect Pricing', value: 'tireConnect' , showSelected: 'TireConnect Pricing'});
      this.pricingMatrixOptions = this.tireConnectList;
      this.selectedPricingMatrix = { name: 'TireConnect Pricing', value: 'tireConnect', showSelected: 'TireConnect Pricing' };

      this.multipleGenericFiltersObject.pricingMatrix.data = this.pricingMatrixOptions;
      this.multipleGenericFiltersObject.pricingMatrix.selected = [this.selectedPricingMatrix || {}];
    }

    if (this.isOpenFromReplenishment) {
      this.isQTQAddOnEnable = false;
    }
    if (customer?.customerId) {
      if (customer?.isFleetCustomer) {
        this.selectedPricingMatrix = { name: 'Fleet Customers Pricing', value: 'fleet', showSelected: 'Fleet Customers Pricing' };
        this.multipleGenericFiltersObject.pricingMatrix.selected = [this.selectedPricingMatrix || {}];
      }
    }

    this.multipleGenericFiltersObject.tireQuantity.data = this.getTireQtyData();
    if (!this.dataService.isAttributeBasedPricingEnable) {
      this.multipleGenericFiltersKeys = this.multipleGenericFiltersKeys.filter((key) => key !== 'pricingMatrix');
    }
    // if (this.isOpenFromQuickTireLookup) {
    //   this.isLoading = false;
    //   this.isTireSizesLoading = false;
    //   if (this.isTireHubEnabled) {
    //     this.selectedTab = 1;
    //   } else if (this.isTireConnectEnabled) {
    //     this.selectedTab = 2;
    //   }
    // }

    if (this.isTireStorage2Enabled && this.isRunTireStorageFlow && this.isOpenFromQuickTireLookup) {
      this.onVehicleSelect(vehicle);
    }

    if (!this.isOpenFromQuickTireLookup) {
      this.getTireSizesAndStock(true);
    }

    if (selectedTab === 2 || selectedTab === 1) {
      this.attrType = 'tireWidths';
    }

    if (this.isOpenFromQuickTireLookup) {
      this.dialogTitle = 'Quick Tire Lookup';
    } else {
      this.dialogTitle = headingTitle || 'Add Tires to RO';
    }

    if (this.isQTQAddOnEnable) {
      this.getQtqAdOnServices();
      this.getTaxesListWithDefaultTax();
    }
  }

  onSerachTireSize(key: string, query: string) { }

  getTireQtyData(): any[] {
    let data: any[] = [];
    for (let i = 1; i < 100; i++) {
      data.push({
        name: `${i}`,
        value: i,
        showSelected: `Qty: ${i}`,
      });
    }

    return data;
  }

  onSearchVehicle(query: string) {
    if (query) {
      this.isVehicleSearching = true;
      this.httpService
        .searchMotorVehicle(query && query.toLowerCase(), '', false)
        .then(
          (result: any) => {
            this.searchVehicleBy = '';
            if (!result) return;

            this.searchVehicleBy = result.SearchType;
            this.vehicleSuggestions = [...result.Vehicles.map((vehicle: any) => this.helperService.setVehicleMotorSearchResults(vehicle, this.vehicleQuery))];
          },
          (err) => {
            this.helperService.showToaster('error', err);
          },
        )
        .finally(() => {
          this.isVehicleSearching = false;
        });
    } else {
      this.searchQuery = '';
      this.vehicleSuggestions = [];
    }

  }

  handleAdonServicetotalChange(event: any) {
    this.defaultServiceTotal = event?.defaultServiceTotal || 0;
    if (event?.selectedAdonService) {
      this.defaultAdonService = event?.selectedAdonService;
      this.multipleGenericFiltersObject.adonServices.selected = [this.defaultAdonService || {}];
    }
    this.calculateSalesTaxOnAdonService(event?.serviceTotalTaxAbleAmt);
  }

  calculateSalesTaxOnAdonService(serviceTotalTaxAbleAmt: number) {
    const taxOnAdOnService = this.calculationService.calculateOrderItemTaxes({
      total: serviceTotalTaxAbleAmt || 0,
      taxRates: this.selectedTax?.taxRates,
      roundOffTax: false,
    });
    this.taxAmtOnAdonService = taxOnAdOnService.taxAmt;
  }

  filterChange(event: any) {
    if (event?.tireQuantity) {
      if (event.tireQuantity?.selected && event.tireQuantity.selected?.length) {
        this.selectedQty = event.tireQuantity.selected[0].value;
      } else {
        this.selectedQty = 4;
      }
    }

    if (event?.adonServices) {
      if (event.adonServices?.selected && event.adonServices.selected?.length) {
        this.defaultAdonService = event.adonServices.selected[0];
      }
    }

    if (event?.companyTaxes) {
      if (event.companyTaxes?.selected && event.companyTaxes.selected?.length) {
        this.selectedTax = event.companyTaxes.selected[0];
      }
    }

    if (event?.pricingMatrix) {
      if (event.pricingMatrix?.selected && event.pricingMatrix.selected?.length) {
        this.selectedPricingMatrix = event.pricingMatrix.selected[0];
      }
    }
  }

  handleClearSearch() {
    this.vehicleSuggestions = [];
    this.vehicleQuery = '';
  }

  onVehicleSelect(vehicle: any) {
    if (vehicle && vehicle.BaseVehicleID) {
      this.vehicle = vehicle;
      this.vehicle.vehicleBaseId = vehicle.BaseVehicleID;
      this.vehicle.EN = vehicle.EngineID;
      this.vehicle.CO = vehicle.CountryID;
      this.vehicle.SM = vehicle.SubModelID;
      this.vehicleQuery = `${vehicle.Year || ''} ${vehicle.MakeName || ''} ${vehicle.ModelName || ''}`;
      this.vehicleQuery = '';
      this.getTireSizesAndStock(true);
    }
    this.partNumberInput = '';
  }

  openConfirmationRemoveDialog() {
    const ref = this.dialogService.open(ConfirmDismissDialogComponent, {
      width: '30%',
      styleClass: 'small-heading-dialog',
      showHeader: false,
      data: {
        headerIcon: 'fas fa-exclamation-triangle font-icon-red',
        styleClassHeading: 'font-14',
        showFooter: true,
        title: 'Remove Vehicle',
        message: 'Removing your vehicle will remove all items from your cart. Are you sure you want to proceed?',
        button: {
          success: { title: 'Proceed' },
          cancel: { title: 'Cancel' },
        },
      },
    });

    const onClose = ref.onClose.subscribe(({ isSuccess }) => {
      if (isSuccess) {
        this.vehicle = {};
        this.recommendedSizes = [];
        this.inventoryTires = [];
        this.selectedTireSize = '';
        this.vehicleSuggestions = [];
      }

      onClose.unsubscribe();
    });
  }

  getTireSizesAndStock(fetchSizes: boolean = false) {
    const options: any = { fetchSizes, fetchTireHubWareHouses: this.dataService.isTireHubEnabled };

    if (!fetchSizes) {
      const { tireWidth, tireProfile, tireSize } = this.selectedAttr;

      if (tireWidth._id && tireProfile._id && tireSize._id) {
        options.tireWidth = tireWidth._id;
        options.tireProfile = tireProfile._id;
        options.tireSize = tireSize._id;

        options.sizes = [`${options.tireWidth}${options.tireProfile}${options.tireSize}`];
      } else {
        options.sizes = [this.selectedTireSize];
      }
    }

    this.isLoading = true;
    this.isTireSizesLoading = true;
    this.httpService
      .getVehicleRecomendedParts(this.vehicle, options)
      .then(
        ({ tires, sizes, brands = [], seasons = [], loadIndexes = [], speedRatings = [], warehouses = [] }: any) => {
          // Setting sizes and recommended sizes
          if (fetchSizes) {
            this.recommendedSizes = sizes;
            this.isEmptySizes = !sizes?.length;

            if (tires.records?.length) {
              tires.records.forEach((tire: any) => {
                if (tire?.locations?.length) {
                  const [location] = tire.locations;

                  if (location) {
                    tire.warehouse = location;
                  }

                  if (tire?.count > tire?.countAvailable) {
                    tire.count = tire?.countAvailable;
                  }
                }
              });
            }

            this.inventoryTires = (tires && tires.records) || [];
          }

          if (this.recommendedSizes?.length) {
            const [tireSize] = this.recommendedSizes;

            if (tireSize) {
              this.selectedTireSize = tireSize?.value || tireSize?.label;
              this.selectedRecommended = tireSize;
            }
          }

          // Settings filter data
          this.brands = brands?.map((brand: string) => ({ _id: brand, name: brand }));
          this.seasons = seasons?.map((season: string) => ({ _id: season, name: season }));
          this.speedRatings = speedRatings?.map((speedRating: string) => ({ _id: speedRating, name: speedRating }));
          this.loadIndexes = loadIndexes?.map((loadIndex: string) => ({ _id: loadIndex, name: loadIndex }));
          this.warehouses = warehouses?.map(({ locationId, locationName }) => ({ _id: locationId, name: locationName }));
        },
        (err: any) => {
          this.helperService.showToaster('error', err);
        },
      )
      .finally(() => {
        this.isLoading = false;
        this.isTireSizesLoading = false;
      });
  }

  getTireAttr(type: string = 'tireWidths') {
    const options: any = {};

    if (this.selectedAttr.tireWidth && this.selectedAttr.tireWidth._id) {
      options.tireWidth = this.selectedAttr.tireWidth._id;
    }

    if (this.selectedAttr.tireProfile && this.selectedAttr.tireProfile._id) {
      options.tireProfile = this.selectedAttr.tireProfile._id;
    }

    this.httpService.getTireAttr(options).then(
      (attr) => {
        if (type === 'tireWidths') {
          this.tireWidths = attr.tireWidths;
        } else if (type === 'tireSizes') {
          this.tireSizes = attr.tireSizes;
        } else if (type === 'tireProfiles') {
          this.tireProfiles = attr.tireProfiles;
        }
      },
      (err) => {
        this.helperService.showToaster('error', err);
      },
    );
  }

  setTireSizeAttr({ widths = [], profiles = [], sizes = [] }) {
    this.tireSizes = sizes;
    this.tireWidths = widths;
    this.tireProfiles = profiles;
  }

  handleRecommendedSelection(size: string, isSelected: boolean, selectedRecommended: any) {
    //event.stopPropagation();

    this.pageNumber = 1;

    // Remove custom size search when using recommended sizes
    this.selectedAttr = {
      tireWidth: { _id: null },
      tireProfile: { _id: null },
      tireSize: { _id: null },
    };

    this.selectedTireSize = size;
    this.selectedRecommended = selectedRecommended;
  }

  handleFocusSize(key: string, value: boolean) {
    this.tireSearchSizeFocus[key] = value;
    Object.keys(this.tireSearchSizeFocus)?.forEach((keyValue: string) => {
      if (key === keyValue) {
        this.tireSearchSizeFocus[key] = value;
      } else {
        this.tireSearchSizeFocus[keyValue] = false;
      }
    });
  }

  getTireByPartNumber = debounce((valueText: string) => {
    this.partNumberInput = valueText;
  }, 600);

  handleSizeSelectQTQ(key: string, valueText: any) {
    this.attrType = '';
    this.cdr.detectChanges();
    const value = { name: valueText, _id: valueText };
    if (key === 'tireWidth') {
      if (value !== this.selectedAttr.tireWidth._id) {
        this.selectedAttr.tireWidth = value;

        //this.selectedAttr.tireProfile = null;
        //this.selectedAttr.tireSize = null;

        this.tireProfiles = [];
        this.tireSizes = [];

        // if (this.selectedTab === 2 || this.selectedTab === 1) {
        //   this.attrType = 'tireProfiles';
        // } else {
        //   this.getTireAttr('tireProfiles');
        // }

        if (valueText?.length === 3) {
          this.handleFocusSize('tireProfile', true);
        }
      }
    } else if (key === 'tireProfile') {
      this.selectedAttr.tireProfile = value;

      //this.selectedAttr.tireSize = null;
      this.tireSizes = [];

      // if (this.selectedTab === 2 || this.selectedTab === 1) {
      //   this.attrType = 'tireSizes';
      // } else {
      //   this.getTireAttr('tireSizes');
      // }
      if (valueText?.length === 2 || Number(valueText) === 0) {
        this.handleFocusSize('tireSize', true);
      }
    } else if (key === 'tireSize') {
      this.selectedAttr.tireSize = value;
      // this.getTireSizesAndStock();
    }
    this.selectedRecommended = {};

    const { tireWidth, tireProfile, tireSize } = this.selectedAttr;

    if (tireWidth?._id || tireProfile?._id || tireSize?._id) {
      this.selectedTireSize = `${tireWidth?._id || ''}${tireProfile?._id || ''}${tireSize?._id || ''}`;
      this.selectedRecommended.tireWidth = tireWidth?._id || '';
      this.selectedRecommended.tireProfile = tireProfile?._id || '';
      this.selectedRecommended.tireSize = tireSize?._id || '';
    } else {
      this.selectedTireSize = '';
      this.selectedRecommended = {};
    }

    // if (tireWidth?._id && tireProfile?._id && tireSize?._id) {
    //   this.selectedTireSize = `${tireWidth._id}${tireProfile._id}${tireSize._id}`;
    //   this.selectedRecommended.tireWidth = tireWidth._id;
    //   this.selectedRecommended.tireProfile = tireProfile._id;
    //   this.selectedRecommended.tireSize = tireSize._id;
    // } else {
    //   this.selectedTireSize = '';
    //   this.selectedRecommended = {};
    // }
  }

  handleSizeSelect(key: string, value: any) {
    this.attrType = '';
    this.cdr.detectChanges();
    if (key === 'tireWidth') {
      if (value !== this.selectedAttr.tireWidth._id) {
        this.selectedAttr.tireWidth = value;

        this.selectedAttr.tireProfile = null;
        this.selectedAttr.tireSize = null;

        this.tireProfiles = [];
        this.tireSizes = [];

        if (this.selectedTab === 2 || this.selectedTab === 1) {
          this.attrType = 'tireProfiles';
        } else {
          this.getTireAttr('tireProfiles');
        }
      }
    } else if (key === 'tireProfile') {
      this.selectedAttr.tireProfile = value;

      this.selectedAttr.tireSize = null;
      this.tireSizes = [];

      if (this.selectedTab === 2 || this.selectedTab === 1) {
        this.attrType = 'tireSizes';
      } else {
        this.getTireAttr('tireSizes');
      }
    } else if (key === 'tireSize') {
      this.selectedAttr.tireSize = value;
      // this.getTireSizesAndStock();
    }
    this.selectedRecommended = {};
    this.partNumberInput = '';

    const { tireWidth, tireProfile, tireSize } = this.selectedAttr;

    if (tireWidth?._id && tireProfile?._id && tireSize?._id) {
      this.selectedTireSize = `${tireWidth._id}${tireProfile._id}${tireSize._id}`;
      this.selectedRecommended.tireWidth = tireWidth._id;
      this.selectedRecommended.tireProfile = tireProfile._id;
      this.selectedRecommended.tireSize = tireSize._id;
    } else {
      this.selectedTireSize = '';
      this.selectedRecommended = {};
    }
  }

  handleClose(isSuccess?: boolean, services: any[] = []) {
    this.dynamicDialogRef.close({ isSuccess, data: { services } });
  }

  handleValidation() {
    let isValid = true;

    Object.keys(this.selectedTire).forEach((tireId) => {
      if (!(this.selectedTire[tireId] && this.selectedTire[tireId].service)) {
        isValid = false;
      }
    });

    return isValid;
  }

  handleUpdateSelectedItemCount(source: string, count: number) {
    this.selectedItemCount[source] = count;
  }

  handleTabChange(tab: any) {
    if (tab?.originalEvent?.currentTarget?.innerText === 'AL Inventory') {
      this.selectedTab = 0;
      this.alPricingList = this.helperService.deepCopy(this.pricingMatrixOptions);
      this.alPricingList.pop();
      this.alPricingList.push({ name: 'AL Pricing', value: 'AlPricing', showSelected: 'AL Pricing' });
      this.multipleGenericFiltersObject.pricingMatrix.data = this.alPricingList;
    } else if (tab?.originalEvent?.currentTarget?.innerText === 'TireHub') {
      this.selectedTab = 1;
      this.pricingMatrixOptions = this.tireHubList;
      this.multipleGenericFiltersObject.pricingMatrix.data = this.pricingMatrixOptions;
    } else if (tab?.originalEvent?.currentTarget?.innerText === 'TireConnect') {
      this.selectedTab = 2;
      this.pricingMatrixOptions = this.tireConnectList;
      this.multipleGenericFiltersObject.pricingMatrix.data = this.pricingMatrixOptions;
    } else {
      this.selectedTab = tab?.index;
    }

    this.attrType = '';
    if (!this.isQTQAddOnEnable) {
      this.selectedAttr = {
        tireWidth: { _id: null },
        tireProfile: { _id: null },
        tireSize: { _id: null },
      };
    }

    this.cdr.detectChanges();
    if (this.selectedTab === 2 || this.selectedTab === 1) {
      this.attrType = 'tireWidths';
    }
  }

  handleSubmit() {
    if (!this.handleValidation()) return;

    const services = [];

    Object.values(this.selectedTire).forEach((data: any) => {
      if (data.service && data.service._id) {
        const serviceIndex = findIndex(services, { _id: data.service._id });

        if (serviceIndex === -1) {
          services.push({ _id: data.service._id, items: [data] });
        } else {
          services[serviceIndex].items.push(data);
        }
      } else if (data.service && data.service.serviceTempId) {
        const serviceIndex = findIndex(services, { serviceTempId: data.service.serviceTempId });

        if (serviceIndex === -1) {
          services.push({ ...data.service, items: [data] });
        } else {
          services[serviceIndex].items.push(data);
        }
      }
    });

    this.handleClose(true, services);
  }

  handleSelectTire(event: any) {
    this.selectedTire = event;
    this.isTireSelected = this.selectedTire && Object.keys(this.selectedTire).length > 0;
    if (this.selectedTab === 0) {
      this.handleAlTireValidation();
    }
  }

  handleCreateInvetoryOrder(data: any) {
    const order = {
      orderType: 'TireConnect',
      module: 'inventory',
      isOnlineOrder: true,
      quote: data?.cartDetails,
    };
    this.openProcessingDismissDialog();
    this.httpService.createTireConnectInventoryPO({ order }).then(
      (res: any) => {
        if (res?.length) {
          this.dataService.sendData(this.dataService.typePassData('processing-dismiss-succcess', { module: 'tireconnect-inventory', id: res[0]?.orderGroupId }));
        }
      },
      (error: any) => {
        this.helperService.showToaster('error', error);
      },
    );
  }

  handleAddCustomerAndVehicle(data: any) {
    let objData: any = {};
    const onlineOrderSource = data.onlineOrderSource || [];
    if (this.isQTQAddOnEnable) {
      objData = data;
    } else {
      objData = {
        cartDetails: data.cartDetails || [],
        source: data.source,
        vehicleOnCart: this.vehicle,
      };
    }
    if (this.isRunTireStorageFlow) {
      const { customer } = this.dynamicDialogConfig.data;
      objData.hasTireConnectCart = onlineOrderSource.includes('tireconnect');
      objData.hasTireHubCart = onlineOrderSource.includes('tirehub');
      objData.hasAlInventoryCart = onlineOrderSource.includes('autoleap');
      objData.customer = {
        customerId: customer?.customerId,
      };
      objData.isTireScheduleForReturn = this.isRunTireStorageFlow;
      objData.tireStorageId = this.tireStorageId;
      objData.vehicle = { ...this.vehicle, customerId: customer?.customerId, customerName: customer?.displayName };
      this.applyFleetCustomerPricingMatrixOverride(objData.adonServices, this.customFleetSettings);
      if (this.isQTQAddOnEnable) {
        this.saveGlobalCartQuickTireData(objData);
      } else {
        this.saveQuickTireData(objData);
      }
    } else {
      const ref = this.dialogService.open(AddDialogComponent, {
        width: '45%',
        styleClass: 'add-dialog add-dialog-combine add-appt-modal',
        showHeader: false,
        data: {
          tab: 'add-vehicle',
          from: 'quick-tire-lookup',
          data: objData,
        },
      });

      const onClose = ref.onClose.subscribe(({ isSuccess, data }) => {
        if (isSuccess && data) {
          console.log(data);
          if (this.isQTQAddOnEnable) {
            this.saveGlobalCartQuickTireData(data);
          } else {
            this.saveQuickTireData(data);
          }
        }

        onClose.unsubscribe();
      });
    }
  }

  openProcessingDismissDialog() {
    const ref = this.dialogService.open(ProcessingDismissDialogComponent, {
      width: '419px',
      styleClass: `add-dialog processing-dimiss-dialog`,
      showHeader: false,
      data: {
        headingTitle: 'Adding vehicle and tire(s)',
        message: 'Please give us a few moments to add vehicle and tire(s) to the RO.',
      },
    });

    const onClose = ref.onClose.subscribe(({ isSuccess, data }) => {
      if (isSuccess && data) {
        if (data?.module === 'tireconnect-inventory' && data?.id) {
          const url = `${config.redirectUrl.purchaseTireConnectOnlineOrder}/${data?.id}`;
          if (this.isRunTireStorageFlow) {
            this.sendDataToTireStorageDrawer({ url, estimate: data });
          } else {
            this.helperService.openPageInNewExistingTab(url, data.id);
          }
          this.dynamicDialogRef.close({ isSuccess, data });
        } else {
          const queryParams = {
            browserSessionToken: data?.restriction?.token || '',
            checkPreferredLocation: data?.checkPreferredLocation || false,
          };

          const url = this.helperService.constructQueryParams(`/estimate/${data._id}`, queryParams);
          if (this.isRunTireStorageFlow) {
            this.sendDataToTireStorageDrawer({ url, estimate: data });
          } else {
            this.helperService.openPageInNewExistingTab(url, data._id);
          }

          // this.helperService.openPageInNewExistingTab(`/estimate/${data._id}?browserSessionToken=${data?.restriction?.token ? data.restriction.token : ''}`, '_blank');
          this.dynamicDialogRef.close({ isSuccess, data });
        }
      }

      onClose.unsubscribe();
    });
  }

  sendDataToTireStorageDrawer(data: any) {
    this.dataService.sendData(
      this.dataService.typePassData('tire-storge-flow-ro-created', {
        type: 'tire-storge-flow-ro-created',
        data,
      }),
    );
  }

  saveGlobalCartQuickTireData(data: any) {
    //TODO : API call to save the data
    this.openProcessingDismissDialog();

    data.browserSessionId = Date.now();
    data.createdFrom = 'QTQ';
    data.selectedTax = this.selectedTax;

    this.httpService.createRepairOrderGlobalCart(data).then(
      (order) => {
        if (order?._id) {
          this.postQuickTireCustomEvent(order);
          this.dataService.sendData(this.dataService.typePassData('processing-dismiss-succcess', order));
        }
      },
      (err) => {
        this.helperService.showToaster('error', err);
      },
    );
  }

  saveQuickTireData(data: any) {
    //TODO : API call to save the data
    this.openProcessingDismissDialog();

    data.browserSessionId = Date.now();
    data.createdFrom = 'QTQ';

    this.httpService.createRepairOrder(data).then(
      (order) => {
        if (order?._id) {
          this.postQuickTireCustomEvent(order);
          this.dataService.sendData(this.dataService.typePassData('processing-dismiss-succcess', order));
        }
      },
      (err) => {
        this.helperService.showToaster('error', err);
      },
    );
  }

  postQuickTireCustomEvent(order) {
    if (this.dataService.isGainSightPXEnabled) {
      const estimateCreated: any = {
        roCreationSource: `Quick Tire Lookup`,
        roNumber: order.code || '',
      };

      this.helperService.postGainsightPXEvent('RO Created', estimateCreated);
    }
  }

  handleAlTireValidation(event: any = null) {
    this.isTireSelected = this.selectedTire && Object.keys(this.selectedTire).length > 0;
    if (Object.keys(this.selectedTire)?.length > 0) {
      if (event) {
        const { tireId, tire } = event;
        if (tireId && tire && this.selectedTire[tireId]) {
          this.selectedTire[tireId] = tire;
        }
      }
      Object.keys(this.selectedTire).forEach((tireId) => {
        if (this.selectedTire[tireId].countAvailable < this.selectedTire[tireId].count) {
          this.isTireSelected = false;
        }
      });
    }
  }

  setGlobalCart(event: any) {
    this.globalCartItemMap[event.source] = event;
    let cartItemList: any[] = Object.values(this.globalCartItemMap);
    let cartCount: number = 0;
    let globalCartOrderTotal = 0;
    Object.keys(this.globalCartItemMap).forEach((key: string) => {
      //cartItemList = cartItemList.concat(this.globalCartItemMap[key].cartListItems);
      cartCount += this.globalCartItemMap[key].cartSummary.count;
      globalCartOrderTotal += this.globalCartItemMap[key].cartSummary?.grandPrice;
      this.isAllCountAvailable = !!this.globalCartItemMap[key].cartSummary.count;
    });

    if (event.callingFrom) {
      if (this.globalCartItemList && this.globalCartItemList?.length) {
        this.globalCartItemList.forEach((cartItem: any) => {
          if (cartItem.source === event.source) {
            cartItem.cartSummary = this.globalCartItemMap[event.source].cartSummary;
            if (event.callingFrom === 'handleTireSelect') {
              cartItem.cartitemList = this.globalCartItemMap[event.source].cartitemList;
            } else {
              cartItem.cartitemList.forEach((item: any) => {
                const cartListItem = find(this.globalCartItemMap[event.source].cartitemList, { warehouseId: item.warehouseId });
                if (cartListItem && cartListItem.total) {
                  item.total = cartListItem.total;
                }
              });
            }
          }
        });
      }

      if (event.callingFrom === 'handleTireSelect' && !this.globalCartItemMap[event.source]?.cartitemList?.length) {
        const index = findIndex(this.globalCartItemList, { source: event.source });
        if (index > -1) {
          this.globalCartItemList.splice(index, 1);
        }
        if (!this.globalCartItemMap[event.source]?.cartitemList?.length) {
          delete this.globalCartItemMap[event.source];
        }
      } else if (event.callingFrom === 'handleTireSelect') {
        if (!this.globalCartItemList?.length && cartItemList?.length) {
          this.globalCartItemList = cartItemList;
        }
      }
    } else {
      this.globalCartItemList = cartItemList;
    }
    Object.keys(this.globalCartItemMap).forEach((key: string) => {
      this.isAllCountAvailable = !!this.globalCartItemMap[key].cartSummary.count;
    });
    this.globalCartCount = cartCount;
    this.globalCartOrderTotal = globalCartOrderTotal;
  }

  getTaxesListWithDefaultTax() {
    this.httpService.getCompanyTaxesList().then(
      (res: any) => {
        if (res?.taxCodes?.length) {
          const taxesArray: any[] = res?.taxCodes?.filter(({ status }) => status) || [];
          if (taxesArray?.length) {
            taxesArray.forEach((tax: any) => {
              tax.id = tax?._id;
              tax.title = tax?.name;
              tax.name = `${tax?.name} - ${tax?.salesTaxRate}%`;
            });
            this.multipleGenericFiltersObject.companyTaxes.data = taxesArray;
            let [defaultTax]: any = taxesArray.filter((t: any) => t?.default);
            if (this.isOpenFromRO) {
              const taxFromRO = find(taxesArray, { id: this.roSelectedTax?.id });
              if (taxFromRO) {
                defaultTax = taxFromRO;
              }
            }
            if (defaultTax) {
              this.selectedTax = defaultTax;
              this.multipleGenericFiltersObject.companyTaxes.selected = [defaultTax];
            } else {
              this.selectedTax = taxesArray[0];
              this.multipleGenericFiltersObject.companyTaxes.selected = [taxesArray[0]];
            }
          }
        }
        this.isTaxesLoaded = true;
      },
      (err) => {
        this.helperService.showToaster('error', err);
      },
    );
  }

  getQtqAdOnServices() {
    this.httpService.getQtqAdonServices().then(
      (res: any) => {
        if (res && res.length) {
          const adOnServices: any[] = res;
          this.defaultAdonService = find(adOnServices, { qtqDefault: true });
          this.adOnServicesObj = {
            source: 'tireAdonService',
            adOnServices: adOnServices,
          };

          this.multipleGenericFiltersObject.adonServices.data = adOnServices || [];
          this.multipleGenericFiltersObject.adonServices.selected = [this.defaultAdonService || {}];

          if (!Object.keys(this.defaultAdonService || {})?.length) {
            this.defaultAdonService = adOnServices[0];
          } else {
            this.defaultServiceTotal = this.defaultAdonService?.serviceTotal.total;
          }
        }
        this.isAdOnServicesLoads = true;
      },
      (err) => {
        this.helperService.showToaster('error', err);
      },
    );
  }

  handleGlobalCartAction(event: any) {
    const { action } = event;
    if (event && event.action) {
      let payload: any = {};
      let globalCartDetails: any = {};
      const sources: any[] = Object.keys(this.globalCartItemMap) || [];
      if (sources?.length) {
        sources.forEach((source: string) => {
          if (source === 'tireconnect') {
            globalCartDetails[source] = { items: Object.values(this.globalCartItemMap[source].cartDetails), warehouses: this.globalCartItemMap[source].cartitemList };
          } else {
            globalCartDetails[source] = Object.values(this.globalCartItemMap[source].cartDetails);
          }
        });
      }
      payload.cart = globalCartDetails;
      payload.adonServices = event?.adonServices || {};
      payload.onlineOrderSource = sources;
      payload.cartOutTheDoor = event.cartOutTheDoor;
      payload.selectedTax = this.selectedTax;
      payload.selectedPricingMatrix = this.getSelectedPricingMatrix(sources);
      if (action === 'go-to-estimate') {
        this.applyFleetCustomerPricingMatrixOverride(payload.adonServices, this.customFleetSettings);
        payload.hasTireConnectCart = sources.includes('tireconnect');
        payload.hasTireHubCart = sources.includes('tirehub');
        payload.hasAlInventoryCart = sources.includes('autoleap');
        if (this.isEditMode) {
          delete payload.adonServices;
          this.handleModifyAddToEstimate(payload);
        } else {
          this.handleAddToEstimate(payload);
        }
      } else if (action === 'add-customer-vehicle') {
        this.handleGlobalCartAddCustomerAndVehicle(payload);
      }
    }
  }

  getSelectedPricingMatrix(source) {
    if (!this.dataService.isAttributeBasedPricingEnable) return null;
    try {
      const _selectedMatrix: any = this.selectedPricingMatrix;
      if (this.selectedPricingMatrix && ['regular', 'fleet', 'custom'].includes(_selectedMatrix.type)) {
        if (source?.length && source.includes('tireconnect')) {
          const pricingRule = this.tireConnectSettings?.tire?.pricingRule?.filter((rule) => rule.name === this.selectedPricingMatrix?.name);
          return pricingRule[0];
        } else if (source?.length && source.includes('tirehub')) {
          const pricingRule = this.tireHubSettings?.tire?.pricingRule?.filter((rule) => rule.name === this.selectedPricingMatrix?.name);
          return pricingRule[0];
        } else {
          return {};
        }
      } else {
        if (source?.length && source.includes('tireconnect')) {

          return { ...this.tireConnectSettings?.tire?.pricing, pricingRuleId: null };
        } else if (source?.length && source.includes('tirehub')) {
          return { ...this.tireHubSettings?.tire?.pricing, pricingRuleId: null };
        }
        return {};
      }
    } catch (e) {
      console.error("Error in getSelectedPricingMatrix:", e);
      return {};
    }
  }

  applyFleetCustomerPricingMatrixOverride(payloadAdonServices: any, customerInfo: any) {
    if (customerInfo?.isFleetCustomer && payloadAdonServices?.items?.length) {
      const { isLaborRateOverride, isPricingMatrixOverride, customLaborRate, customPartPricingMatrix } = customerInfo;
      payloadAdonServices?.items?.forEach((item: any) => {
        if (item.type === 'labor' && isLaborRateOverride && customLaborRate) {
          item.billRate = customLaborRate && customLaborRate.rate;
          item.price = item.billRate * item.billableHours;
          item.pricing = { pricingId: customLaborRate.pricingId, name: customLaborRate.name };
        }

        if (['part', 'tire'].includes(item.type)) {
          if (isPricingMatrixOverride && customPartPricingMatrix) {
            item.pricing = { pricingId: customPartPricingMatrix.pricingId, name: customPartPricingMatrix.name };
            item.price = this.calculationService.calculateMarkUpUsingPricing(item.cost, customPartPricingMatrix);
          }
        }
      });
    }
  }

  handleModifyAddToEstimate(payload: any) {
    this.isSubmitting = true;
    payload.estimateId = this.orderId;
    this.httpService
      .modifyGlobalCartOnEstimate(payload)
      .then(
        (res) => {
          this.dynamicDialogRef.close({ isSuccess: true, data: { isReloadNeeded: true } });
          this.helperService.showToaster('error', 'The shipping charges provided on unordered items are estimated, once the order is placed the charges are rechecked and updated.');
        },
        (err) => {
          this.helperService.showToaster('error', err);
        },
      )
      .finally(() => {
        this.isSubmitting = false;
      });
  }

  handleGlobalCartAddCustomerAndVehicle(payload: any) {
    payload.vehicleOnCart = this.vehicle;
    this.handleAddCustomerAndVehicle(payload);
  }

  handleAddToEstimate(payload: any) {
    this.isSubmitting = true;
    payload.estimateId = this.orderId;
    this.httpService
      .addGlobalCartToEstimate(payload)
      .then(
        (res) => {
          this.dynamicDialogRef.close({ isSuccess: true, data: { isReloadNeeded: true } });
          this.helperService.showToaster('error', 'The shipping charges provided on unordered items are estimated, once the order is placed the charges are rechecked and updated.');
        },
        (err) => {
          this.helperService.showToaster('error', err);
        },
      )
      .finally(() => {
        this.isSubmitting = false;
      });
  }

}
